import React from 'react';
import { Construction } from 'lucide-react';

interface ComingSoonProps {
  appName: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ appName }) => {
  return (
    <div className="h-full flex items-center justify-center bg-background">
      <div className="text-center p-8">
        <Construction size={64} className="mx-auto mb-4 text-muted-foreground" />
        <h2 className="text-2xl font-bold text-foreground mb-2">{appName}</h2>
        <p className="text-muted-foreground mb-4">
          This application is coming soon in a future update!
        </p>
        <p className="text-sm text-muted-foreground">
          MapleOS 26.2 is still in development. Check back later for more features.
        </p>
      </div>
    </div>
  );
};